import * as React from 'react';

import { defaultAppConfig } from './AppConfigStore/config';
import { IAppConfigBootstrap, IAppConfigReady } from './AppConfigStore/types/client';
import { RootStore } from './RootStore';
import { rootStore } from './instance';

type RootStoreContextValue = RootStore;

const RootStoreContext = React.createContext<RootStoreContextValue | null>(null);

export const RootStoreProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  React.useEffect(() => {
    rootStore.appConfigStore.fetchConfig();
  }, []);

  return <RootStoreContext.Provider value={rootStore}>{children}</RootStoreContext.Provider>;
};

export const useRootStore = () => {
  const context = React.useContext(RootStoreContext);

  if (!context) {
    throw new Error('RootStoreContext was not provided');
  }

  return context;
};

export const useAppConfigBootstrap = (): IAppConfigBootstrap => {
  const store = useRootStore().appConfigStore;

  return {
    isLoading: store.isLoading,
    error: store.error,
    isReady: store.isReady,
    bootstrapUi: store.isReady ? store.ui : defaultAppConfig.ui,
  };
};

export const useAppConfig = (): IAppConfigReady => {
  const store = useRootStore().appConfigStore;

  if (!store.isReady) {
    throw new Error('useAppConfig() called before app config is loaded');
  }

  return store;
};
